var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"vmp-media-check__step-icon vh-iconfont",class:[_vm.iconStyles]})
}
var staticRenderFns = []

export { render, staticRenderFns }